import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Translate from "../../../utils/Translate";
import { useEffect, useState } from "react";
import { useApi } from "../../../utils/Api";

export default function UserCrud({ onClose, onSaved, user, availableReadOnlyProfileTypes }) {
  const [title] = useState(user?.ePortUserId ? Translate.get("EditReadonlyUser") : Translate.get("AddReadonlyUser"));
  const [userData, setUserData] = useState(user);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (
      !user.ePortUserId &&
      !user.ePortCloudLicenseLineType &&
      !userData.ePortCloudLicenseLineType &&
      !!availableReadOnlyProfileTypes &&
      availableReadOnlyProfileTypes.length > 0
    ) {
      setUserData((prev) => ({ ...prev, ePortCloudLicenseLineType: availableReadOnlyProfileTypes[0] }));
    }
  }, [user, userData, availableReadOnlyProfileTypes]);

  const api = useApi();

  async function postAddOrUpdateUser() {
    setIsLoading(true);
    const response = await api.fetch(
      `${import.meta.env.VITE_MAIN_URL}licenses/eport/users/readonly`,
      userData,
      "POST",
    );
    setIsLoading(false);

    if (response.isSuccessful) {
      await onSaved();
      onClose();
    }
  }
  console.log("availableReadOnlyProfileTypes", availableReadOnlyProfileTypes);
  return (
    <>
      <Dialog maxWidth={false} className="stdDialog" scroll="paper" onClose={onClose} open={true}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent className="stdDialogContent">
          <Stack gap="16px" marginTop="16px">
            <Stack direction="row" gap="16px">
              <TextField
                label={Translate.get("FirstName")}
                value={userData.firstName ?? ""}
                onChange={(ev) =>
                  setUserData((prev) => ({
                    ...prev,
                    firstName: ev.target.value,
                  }))
                }
                fullWidth
                required
              />
              <TextField
                label={Translate.get("LastName")}
                value={userData.lastName ?? ""}
                onChange={(ev) =>
                  setUserData((prev) => ({
                    ...prev,
                    lastName: ev.target.value,
                  }))
                }
                fullWidth
                required
              />
            </Stack>
            <TextField
              label={Translate.get("Email")}
              value={userData.ePortAccountId ?? ""}
              onChange={(ev) =>
                setUserData((prev) => ({
                  ...prev,
                  ePortAccountId: ev.target.value,
                }))
              }
              required
            />
            <FormControl fullWidth>
              <InputLabel id="profile">{Translate.get("Profile")}</InputLabel>
              <Select
                fullWidth
                labelId="profile"
                id="profile"
                disabled={availableReadOnlyProfileTypes.length <= 1}
                value={userData.ePortCloudLicenseLineType ?? ""}
                label={Translate.get("Profile")}
                onChange={(event) =>
                  setUserData((prev) => ({ ...prev, ePortCloudLicenseLineType: event.target.value }))
                }
              >
                {availableReadOnlyProfileTypes.map((x) => (
                  <MenuItem key={x} value={x}>
                    {Translate.getEPortLicenseLineType(x)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {!user.ePortUserId && (
              <Typography
                variant="body2"
                sx={{
                  marginTop: "16px",
                  color: "text.secondary",
                }}
              >
                {Translate.get("ReadOnlyUserPriceInfo")}
              </Typography>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{Translate.get("Cancel")}</Button>
          <Button
            variant="contained"
            loading={isLoading}
            disabled={!userData.firstName || !userData.lastName || !userData.ePortAccountId}
            onClick={postAddOrUpdateUser}
          >
            {title}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
